import React, { useEffect } from "react";
import { Tweet } from "react-tweet";
import "./style.css";

const tweetIds = [
  "1844500054142239012",
  "1867432935999369529",
  "1851308107139256787",
  "1849207760463757564",
  "1864376180163354750",
  "1869951473213419600",
  "1866437692004675618",
  "1865492138072444935",
  "1865136074013507966",
  "1833628655735419223",
  "1864754443121549625",
  "1864664390743531588",
  "1861791924538970293",
  "1861425822810415211",
  "1854343388532711537",
  "1867612370849476691",
  "1867731653709193467",
  "1861475514332127266",
];

const FamousTweets = () => {
  useEffect(() => {
    if (window.twttr) {
      window.twttr.widgets.load();
    }
  }, []);

  return (
    <div className="tweets-container">
      <h2 className="text-center">Famous Tweets About $SAVEJAMES</h2>
      <div className="tweets-grid">
        {tweetIds.map((tweet, index) => (
          <Tweet key={index} id={tweet} />
        ))}
      </div>
    </div>
  );
};

export default FamousTweets;
